// extracted by mini-css-extract-plugin
export default {"root":"period-selector_root__ZkQ9c","tab":"period-selector_tab__VLD+H","tabActive":"period-selector_tabActive__SiBFS"};